// import { Card } from "@/blocks/Cards/Card/Card";
// import { renderToString } from "react-dom/server";
import { safeStringify } from "@/helpers/utils.helper";
import ContentfulRichText from "@/server/ContentfulRichText";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import classNames from "classnames";
import { lazy, ReactElement, ReactNode } from "react";
import Card from "../Card/Card";

import { Document } from '@contentful/rich-text-types';

// const Card = lazy(() => import('@/blocks/Cards/Card/Card'));

type T_ImageCardProps = {
	// Text:
	title: string;
	subtitle: string;
	description: any;
	hideText: boolean;
	centerTextVertically?: boolean;
	//Font Size
	subtitleFontSize?: 's' | 'm' | 'l' | 'xl';
	titleFontSize?: 's' | 'm' | 'l' | 'xl';
	bodyFontSize?: 'xxs' | 'xs' | 's' | 'm' | 'l' | 'xl';
	// Button:
	btn1_label: string;
	btn1_icon: any;
	btn1_iconPosition: 'hide' | 'top' | 'right' | 'left';
	btn1_variant: string;
	btn1_size: string;
	btn1_action: () => void;
	hideButton: boolean;
	buttonUrl?: string;
	linkTargetBlank: boolean;
	// Image:
	imagePosition: "Normal" | "LeftEdge";
	cardBackgroundColor?: string;
	hideMedia: boolean;
	image: string;
	imageWidth?: string; //number;
	imageHeight?: string; //number;
	imageWrapperWidth?: string;
	imageWrapperHeight?: string;
	imageStartViewX?: string;
	imageStartViewY?: string;
	// Others:
	hideCard?: boolean;
	animated: boolean;
	animationType: string;
	roundedCorners: boolean;
	mediaOverlay?: ReactElement;
	contentMinHeight?: string;
	contentMaxHeight?: string;
	showInSection?: boolean;
	sectionId?: string;
};

export default function ImageCard({
	// Text:
	title,
	subtitle,
	description,
	hideText,
	hideCard = false,
	centerTextVertically = false,
	// Font
	subtitleFontSize = "s",
	titleFontSize = "m",
	bodyFontSize = "l",
	// Button:
	btn1_label = "Show details",
	btn1_icon = 'Placeholder',
	btn1_iconPosition = "hide",
	btn1_variant = "ghost",
	btn1_size = "s",
	btn1_action = () => { },
	hideButton = false,
	buttonUrl = "",
	linkTargetBlank = false,
	// Image:
	image: imageSrc,
	hideMedia = false,
	imagePosition = "Normal",
	cardBackgroundColor = "#FFFFFF",
	imageWidth = "500px",
	imageHeight = "300px",
	imageWrapperWidth = "",
	imageWrapperHeight = 'auto',
	imageStartViewX = '0px',
	imageStartViewY = '0px',
	contentMinHeight = "",
	contentMaxHeight = "auto",
	showInSection = false,
	sectionId = "",
	// Others:
	animated,
	animationType,
	roundedCorners,
	mediaOverlay
}: T_ImageCardProps) {
	const width = 500;
	const height = 300;

	const image = {
		width: width,
		height: height,
		src: imageSrc || `https://placehold.co/${width}x${height}`,
	};

	return (
		<>
			{/* <ContentfulRichText document={description} /> */}
			{/* -- {btn1_variant} --  */}
			{/* {typeof(description)} */}
			{/* {JSON.stringify(description)} */}
			{!hideCard ?
				<Card
					// Text:
					showInSection={showInSection}
					sectionId={sectionId}
					title={title}
					subtitle={subtitle}
					subtitleFontSize={subtitleFontSize}
					titleFontSize={titleFontSize}
					bodyFontSize={bodyFontSize}
					description={description || undefined
						// description ? 
						// 	// renderToString(documentToReactComponents(description))
						// 	//  (()=> <>
						// 	//  	{documentToReactComponents(description)}
						// 	//  </>)()
						// 	// safeStringify(documentToReactComponents(description))
						// 	<ContentfulRichText document={description} />
						// 	// "Hello ImageCard"
						// 	// JSON.stringify(description)
						// : undefined
					}
					hideText={hideText}
					centerTextVertically={centerTextVertically}
					// Button:
					hideButtons={hideButton}
					btn1_label={btn1_label}
					btn1_icon={btn1_icon}
					btn1_iconPosition={btn1_iconPosition}
					btn1_variant={btn1_variant}
					btn1_size={btn1_size}
					btn1_action={btn1_action}
					buttonUrl={buttonUrl}
					linkTargetBlank={linkTargetBlank}
					// Image:
					image={image}
					styles={{
						"backgroundColor": cardBackgroundColor
					}}
					hideMedia={hideMedia}
					mediaWidth={imageWidth}
					mediaHeight={imageHeight}
					mediaWrapperWidth={imageWrapperWidth}
					mediaWrapperHeight={imageWrapperHeight}
					mediaPosition={imagePosition}
					mediaStartViewX={imageStartViewX}
					mediaStartViewY={imageStartViewY}
					// Others:
					animated={animated}
					className={classNames(
						"overflow-hidden !min-w-card-min-width w-full",
						{
							'rounded-image-card': roundedCorners
						}
					)}
					// className={classNames("bg-interactive-image-card !min-w-card-min-width w-full")}
					mediaOverlay={mediaOverlay}
					// roundedCorners={roundedCorners}
					animation={animationType}
					contentMinHeight={contentMinHeight}
					contentMaxHeight={contentMaxHeight}>
				</Card>
				:
				<></>
			}
		</>
	);
}
